import React, { ChangeEvent, useState } from 'react'
import { SvgCross } from '../../assets/images'
import {
  TableFilterInputPropsType,
  TypeBasedTableFilterPropsType,
} from '../../utils'

const TableFilterInput: React.FC<TableFilterInputPropsType> = ({
  handleFilterSearchValue,
  options,
  tableName,
}) => {
  const [searchValues, setSearchValues] = useState<string[]>(options || [])
  const [inputValue, setInputValue] = useState<string>('')
  const handleCommaSeparate = (event: ChangeEvent<HTMLInputElement>) => {
    const fieldValue = event?.currentTarget?.value || ''
    let resultString = ''
    if (fieldValue?.length <= 3 && fieldValue?.endsWith(',')) {
      resultString = fieldValue?.replace(',', '')
    } else if (fieldValue?.length > 3 && fieldValue?.endsWith(',')) {
      resultString = ''
      const filterVal = fieldValue?.replace(',', '')
      setSearchValues((prevValue) => [...prevValue, filterVal])
      handleFilterSearchValue([...searchValues, filterVal])
    } else {
      resultString = fieldValue
    }
    setInputValue(resultString)
  }
  const handleRemovePill = (index: number) => {
    const clonedSearchValue = [...searchValues]
    clonedSearchValue.splice(index, 1)
    setSearchValues(clonedSearchValue)
    handleFilterSearchValue(clonedSearchValue)
  }

  const handleBlur = () => {
    if (inputValue?.trim()?.length > 3)
      handleFilterSearchValue([...searchValues, inputValue])
  }

  return (
    <div>
      <div className="flex flex-wrap border-2 rounded border-accent-500 group-hover:border-secondary-500 focus-within:border-secondary-500">
        {searchValues?.map((val, index) => (
          <div
            key={`${val}-${index}`}
            className="bg-primary-100 rounded-full flex py-1 pr-2 pl-3 items-center m-1"
          >
            <span className="break-all text-xs mr-1 text-center">{val}</span>
            <div
              className="hover:bg-secondary-25 p-1 rounded cursor-pointer"
              onClick={() => handleRemovePill(index)}
            >
              <SvgCross width={'8px'} height={'8px'} />
            </div>
          </div>
        ))}
        <input
          data-qa-id={`table_${tableName}_filter_input`}
          type="text"
          className="outline-none px-2 bg-transparent text-xs min-w-4 break-all my-1"
          value={inputValue}
          onChange={handleCommaSeparate}
          onBlur={handleBlur}
        />
      </div>
    </div>
  )
}

const TypeBasedTableFilter: React.FC<TypeBasedTableFilterPropsType> = ({
  filterCase,
  handleFilterSearchValue,
  filterObject,
  tableName,
}) => {
  if (filterCase === 'string_LIKE') {
    return (
      <div>
        <TableFilterInput
          tableName={tableName}
          handleFilterSearchValue={handleFilterSearchValue}
          options={filterObject?.search_value}
        />
      </div>
    )
  }
  return null
}

export default TypeBasedTableFilter
